import styled from 'styled-components';

interface VerifyCodeProps {
  $width?: string | number;
  $height?: string | number;
  $numberOfBoxes?: number;
  $theme?: string;
  $isError?: boolean;
  $isValid?: boolean;
  $filled?: boolean;
}

export const VerifyCodeWrapper = styled.div<VerifyCodeProps>`
  display: flex;
  gap: 16px;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 0rem;
  min-width: 250px;
  min-height: 60px;

  ${({ $width }) => {
    return $width ? `width: ${$width};` : ``;
  }}
  ${({ $height }) => {
    return $height ? `height: ${$height};` : ``;
  }}
`;

export const BoxInput = styled.input<VerifyCodeProps>`
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  -webkit-appearance: none;
  box-sizing: border-box;
  ${({ $theme, $isError }) => {
    if ($isError) {
      return `
        background-color: #FDE6E6;
        color: #EB0609;
      `;
    }
    return $theme === 'light'
      ? `background-color: #0C0C0C;  color: #D9CEAF;`
      : `background-color: #D9CEAF;  color: #0C0C0C;`;
  }}
  border-radius: 24px;
  border: ${({ $isError }) => {
    return $isError ? '1px solid #EB0609' : 'none';
  }};
  outline: none;

  &::placeholder {
    color: #9eb1cf;
  }

  &:focus {
    border: 1.5px solid rgb(165, 111, 56);
  }

  ${({ $width, $numberOfBoxes }) => {
    return $width && $numberOfBoxes
      ? `width: calc(${
          typeof $width === 'number' ? `${$width}px` : $width
        } / ${$numberOfBoxes} - 4px);`
      : 'width: 56px;';
  }}

  ${({ $height }) => {
    return $height
      ? `height: ${typeof $height === 'number' ? `${$height}px` : $height};`
      : 'height: 56px;';
  }}

  background-color: ${({ $filled }) => ($filled ? '#D9CEAF' : '#DDDEDD')}
`;
